export default class Event{
    static INFO = 0
    static ERROR = 1

    constructor(type=0, message="", triggerToast=false){
        this.message = message
        this.type = type
        this.triggerToast = triggerToast
    }
}

